export default "__VITE_ASSET__6257377b__"